const StatsItem = ({ number, text, color }) => {

  return (

    <div className = "stats__item">

      <div className = "text">

        { text }

      </div>

      <div className = "number" style = {{ color: color }}>

        { number }
        
      </div>

      <div className = "slash" />

    </div>

  );

}

export default StatsItem;